var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEbury(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97.89 35.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3697c4;}.cls-2{fill:#1e5982;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.26,12.82a7.74,7.74,0,0,0-7.37-5.46,10.08,10.08,0,0,0-5.67,1.73V0H23.53V26.33h3.69V24.7c4.08,3.29,8.83,2.39,11.31-.6S41.21,16,40.26,12.82ZM35.87,22A4.45,4.45,0,0,1,32,23.88a8,8,0,0,1-4.75-2.1v-10a11.15,11.15,0,0,1,2.42-1.22c1.5-.51,4-.48,5.31.6A6.54,6.54,0,0,1,37,15.46C37.14,16.88,37.25,19.89,35.87,22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20.6,
    width: 2.93,
    height: 2.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.82,
    y: 7.84,
    width: 2.93,
    height: 2.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 60.24,
    y: 23.39,
    width: 2.93,
    height: 2.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.65 20.45 17.65 23.39 6.97 23.39 6.97 13.73 17.53 13.73 17.53 10.8 6.97 10.8 6.97 2.93 17.65 2.93 17.65 5.88 20.6 5.88 20.6 2.93 20.6 0 17.65 0 0 0 0 2.93 3.17 2.93 3.17 23.39 0 23.39 0 26.33 17.65 26.33 20.6 26.33 20.6 23.39 20.6 20.45 17.65 20.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.61,7.84H53.33v2.93h3.28V21.4a9.67,9.67,0,0,1-4.44,2.29c-3,.54-3.62-.4-4-1a5.75,5.75,0,0,1-.46-2.41V7.84H41.05v2.93h3v9.5a8.39,8.39,0,0,0,.88,4.27,4.94,4.94,0,0,0,2.78,2,9.61,9.61,0,0,0,5.46-.45,11.62,11.62,0,0,0,3.45-2.07v2.28h3.63V7.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72,8.79A7.82,7.82,0,0,0,69.82,11V7.84H63.17v2.93h3V23.39h-3v2.94H74.39V23.39H69.82V13.53a6.79,6.79,0,0,1,2.92-2.17,8.49,8.49,0,0,1,3.08-.59V7.84A7.37,7.37,0,0,0,72,8.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.89,7.84v2.93h2.94l-5,14.37L82.55,10.77h2.87V7.84H78.75v2.93l4.89,15.56h2.78l-1,2.74A4.49,4.49,0,0,1,82.27,32a19.79,19.79,0,0,1-3.56.28v2.95a16.7,16.7,0,0,0,5.21-.5A7.34,7.34,0,0,0,87,32.8a11.44,11.44,0,0,0,2-3.73l6.37-18.3h2.43V7.84Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbury);
export default __webpack_public_path__ + "static/media/ebury.c3125344735d047ce241861503254713.svg";
export { ForwardRef as ReactComponent };